module.exports = __webpack_public_path__ + "img/banner_senior.fca65a8a.png";